import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

export function useAutoConfig(enabled: boolean) {
  const initial = {
    id: 0,
    isAutoChangedStatus: false,
    isAutoMergedLeadToClient: false
  };

  const { data = initial, ...arg } = useQuery<{
    id: number;
    isAutoChangedStatus: boolean;
    isAutoMergedLeadToClient: boolean;
  }>(
    ['crm-lead-auto-config'],
    async () => {
      const { data } = await $api.get('/v1/lead_client_auto_config');

      return { ...(data?.data || {}) };
    },
    {
      enabled
    }
  );

  return { ...data, ...arg };
}
